<div class="auth-wrapper">
  <div class="auth-card">
    <div class="auth-card__header">
      <strong>{{ activeForm | uppercase }}</strong>
    </div>

    <div class="form-container">
      @if (toastMessage) {
        <div class="success-toast">
          <span>{{ toastMessage }}</span>
          <button type="button" class="toast-close" (click)="dismissToast()">
            <i class="fa-solid fa-xmark" aria-hidden="true"></i>
          </button>
        </div>
      }

      <axis-form
        [formType]="activeForm"
        [model]="formModel"
        [showLabels]="true"
        [headingOverride]="'Your Details'"
        [formVariant]="'waitron-auth'"
        (formSubmit)="onFormSubmit($event)"
      ></axis-form>

      <div class="form-links">
        @switch (activeForm) {
          @case ('login') {
            <p>
              Don't have an account?
              <a
                [routerLink]="['/register']"
              [queryParams]="{
                returnUrl: returnUrl,
                email: formModel['email'] || null,
                fName: formModel['firstName'] || null,
                lName: formModel['lastName'] || null,
                phone: formModel['phoneNumber'] || null,
              }"
                >
                Register
              </a>
              @if (showForgot) {
                <a
                  [routerLink]="['/forgot-password']"
                [queryParams]="{
                  returnUrl: returnUrl,
                  email: formModel['email'] || null,
                  fName: formModel['firstName'] || null,
                  lName: formModel['lastName'] || null,
                  phone: formModel['phoneNumber'] || null,
                }"
                  >
                  Forgot password?
                </a>
              }
            </p>
          }
          @case ('register') {
            <p>
              Already have an account?
              <a
                [routerLink]="['/login']"
              [queryParams]="{
                returnUrl: returnUrl,
                email: formModel['email'] || null,
                fName: formModel['firstName'] || null,
                lName: formModel['lastName'] || null,
                phone: formModel['phoneNumber'] || null,
              }"
                >
                Login
              </a>
            </p>
          }
          @case ('forgot') {
            @if (showForgot) {
              <p>
                Remembered your password?
                <a
                  [routerLink]="['/login']"
                [queryParams]="{
                  returnUrl: returnUrl,
                  email: formModel['email'] || null,
                  fName: formModel['firstName'] || null,
                  lName: formModel['lastName'] || null,
                  phone: formModel['phoneNumber'] || null,
                }"
                  >
                  Back to Login
                </a>
              </p>
            }
          }
        }
      </div>
    </div>
  </div>
</div>
